import * as ambassadorWixLoyaltyTransactionV1LoyaltyTransaction from './loyalty-transaction-v1-loyalty-transaction-transactions.http.js';
import * as ambassadorWixLoyaltyTransactionV1LoyaltyTransactionTypes from './loyalty-transaction-v1-loyalty-transaction-transactions.types.js';
import * as ambassadorWixLoyaltyTransactionV1LoyaltyTransactionUniversalTypes from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getLoyaltyTransaction(): __PublicMethodMetaInfo<
  'GET',
  { loyaltyTransactionId: string },
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionUniversalTypes.GetLoyaltyTransactionRequest,
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionTypes.GetLoyaltyTransactionRequest,
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionUniversalTypes.GetLoyaltyTransactionResponse,
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionTypes.GetLoyaltyTransactionResponse
> {
  const payload = { loyaltyTransactionId: ':loyaltyTransactionId' } as any;

  const getRequestOptions =
    ambassadorWixLoyaltyTransactionV1LoyaltyTransaction.getLoyaltyTransaction(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/loyalty-transactions/{loyaltyTransactionId}',
    pathParams: { loyaltyTransactionId: 'loyaltyTransactionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLoyaltyTransactions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionUniversalTypes.QueryLoyaltyTransactionsRequest,
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionTypes.QueryLoyaltyTransactionsRequest,
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionUniversalTypes.QueryLoyaltyTransactionsResponse,
  ambassadorWixLoyaltyTransactionV1LoyaltyTransactionTypes.QueryLoyaltyTransactionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyTransactionV1LoyaltyTransaction.queryLoyaltyTransactions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/loyalty-transactions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LoyaltyTransaction as LoyaltyTransactionOriginal,
  LoyaltyTransactionTransactionTypeInfoOneOf as LoyaltyTransactionTransactionTypeInfoOneOfOriginal,
  TransactionType as TransactionTypeOriginal,
  TransactionTypeWithLiterals as TransactionTypeWithLiteralsOriginal,
  EarnInfo as EarnInfoOriginal,
  EarnInfoActivityDetailsOneOf as EarnInfoActivityDetailsOneOfOriginal,
  FollowedSocialMedia as FollowedSocialMediaOriginal,
  RedeemInfo as RedeemInfoOriginal,
  AdjustInfo as AdjustInfoOriginal,
  RefundInfo as RefundInfoOriginal,
  ExpireInfo as ExpireInfoOriginal,
  EarnAttemptInfo as EarnAttemptInfoOriginal,
  CreateLoyaltyTransactionRequest as CreateLoyaltyTransactionRequestOriginal,
  CreateLoyaltyTransactionResponse as CreateLoyaltyTransactionResponseOriginal,
  BulkCreateLoyaltyTransactionsRequest as BulkCreateLoyaltyTransactionsRequestOriginal,
  BulkCreateLoyaltyTransactionsResponse as BulkCreateLoyaltyTransactionsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkLoyaltyTransactionResult as BulkLoyaltyTransactionResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetLoyaltyTransactionRequest as GetLoyaltyTransactionRequestOriginal,
  GetLoyaltyTransactionResponse as GetLoyaltyTransactionResponseOriginal,
  QueryLoyaltyTransactionsRequest as QueryLoyaltyTransactionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLoyaltyTransactionsResponse as QueryLoyaltyTransactionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  GetTransactionSumRequest as GetTransactionSumRequestOriginal,
  GetTransactionSumResponse as GetTransactionSumResponseOriginal,
  RevertTransactionRequest as RevertTransactionRequestOriginal,
  RevertTransactionResponse as RevertTransactionResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.types.js';
